export default "__VITE_ASSET__S80cmPjz__"